import { useState } from "react";

const useImport = () => {
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleImportClick = () => {
    setImportModalOpen(true);
  };

  const handleImportClose = () => {
    setImportModalOpen(false);
  };

  const handleFileSelect = event => {
    setSelectedFile(event.target.files[0]);
  };

  const handleImportSubmit = () => {
    /*if (file) {
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        onImport(rows);
      };
      reader.readAsArrayBuffer(file);
    }*/
    setImportModalOpen(false);
  };
  return {
    handleImportClick,
    handleFileSelect,
    handleImportSubmit,
    handleImportClose,
    importModalOpen,
    selectedFile
  };
};

export default useImport;
